<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.name") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.publicName") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`publicName`)">
              <input :class="parentProps.class" v-model="form.publicName" type="text" class="form-control " id="publicName">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.type") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`type`)">
            <Multiselect
              :disabled="!!form.id"
              :class="parentProps.class"
              v-model="form.type"
              :options="[Direction.PAY_IN, Direction.PAY_OUT]"
              :custom-label="(opt) => helper.trans(`direction.${opt}`)"
              :multiple="false"
              select-label="Select"
              placeholder=""
            >

            </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="limitsFieldsVisible">
          <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper  v-slot="parentProps" :errors="getErrors(`currency`)">
              <Multiselect id="currency"
                           class=""
                           v-model="form.currency"
                           :options="store.getters['currencyMethods/currencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="limitsFieldsVisible">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.min_sum") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`minSum`)">
              <input :class="parentProps.class" v-model="form.minSum" v-maska data-maska="9.########" data-maska-tokens="9:[0-9]:multiple" inputmode="decimal" type="text" class="form-control " id="minSum">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="limitsFieldsVisible">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.max_sum") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`maxSum`)">
              <input :class="parentProps.class" v-model="form.maxSum" v-maska data-maska="9.########" data-maska-tokens="9:[0-9]:multiple" inputmode="decimal" type="text" class="form-control " id="maxSum">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="form.type === Direction.PAY_IN">
          <label for="paymentOptions" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.group_payment_option") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`paymentOptions`)">
              <Multiselect id="paymentOptions"
                           class="multiselect-sm"
                           v-model="form.paymentOptions"
                           :options="store.getters['currencyMethods/options']()"
                           :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                           :multiple="true"
                           :class="parentProps.class"
                           select-label="Select"
                           :placeholder="helper.trans('labels.payment_options')"
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="receiptsHintFeatureEnabled && form.type === Direction.PAY_OUT">
          <label for="payOutReceiptsHint" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_receipts_hint") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payOutReceiptsHint`)">
              <input :class="parentProps.class" v-model="form.payOutReceiptsHint" type="text" maxlength="255" class="form-control" id="payOutReceiptsHint">
            </FormInputWrapper>
            <small class="text-muted">{{ helper.trans("labels.pay_out_receipts_hint_help") }}</small>
          </div>
        </div>

        <div class="row mt-2" v-if="reuseMinCapFeatureEnabled && form.type === Direction.PAY_IN">
          <label for="reuseMinCapEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.reuse_min_cap") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center mb-2">
              <input v-model="form.reuseMinCapEnabled" class="form-check-input" type="checkbox" id="reuseMinCapEnabled">
            </div>
            <FormInputWrapper v-slot="parentProps" :errors="getReuseMinCapErrors()">
              <CurrencyAmountMapInput v-model="form.reuseMinCaps" :disabled="!form.reuseMinCapEnabled" :class="parentProps.class"></CurrencyAmountMapInput>
            </FormInputWrapper>
            <small class="text-muted">{{ helper.trans("labels.reuse_min_cap_hint") }}</small>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isHidden" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_hidden") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isHidden" class="form-check-input" type="checkbox" id="isHidden">
            </div>
          </div>
        </div>

      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, onMounted, computed} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {api} from "@/service/APIClient";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import TrafficGroupFormDTO from "@/models/form/TrafficGroupFormDTO";
import TrafficGroupUpdateRequestDTO from "@/models/request/TrafficGroupUpdateRequestDTO";
import Multiselect from "vue-multiselect";
import {Direction} from "@/models/enum/Direction";
import CurrencyAmountMapInput from "@/components/Form/CurrencyAmountMapInput.vue";

export default defineComponent({
  props: {
    role: String
  },
  components: {
    Multiselect,
    FormInputWrapper,
    CurrencyAmountMapInput,
  },
  setup() {
    const store = useStore();
    const state = reactive({
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as TrafficGroupFormDTO,
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const reuseMinCapFeatureEnabled = computed<boolean>(() => {
      return !!store.getters.isAdmin && !!store.getters.getAppData?.REQUISITES_REUSE_MIN_SUM_CAP_ENABLED
    })

    const receiptsHintFeatureEnabled = computed<boolean>(() => {
      return !!store.getters.isAdmin && !!store.getters.getAppData?.PAY_OUT_RECEIPTS_HINT_ENABLED
    })

    const payOutLimitsFeatureEnabled = computed<boolean>(() => {
      return !!store.getters.isAdmin && !!store.getters.getAppData?.PAY_OUT_TRAFFIC_GROUP_LIMITS_ENABLED
    })

    const limitsFieldsVisible = computed<boolean>(() => {
      return state.form.type === Direction.PAY_IN
        || (state.form.type === Direction.PAY_OUT && payOutLimitsFeatureEnabled.value)
    })

    const getReuseMinCapErrors = (): ValidationErrorDTO[] => {
      const result: ValidationErrorDTO[] = [];
      for (const [path, fieldErrors] of Object.entries(state.errors)) {
        if (path === 'reuseMinCaps' || path.startsWith('reuseMinCaps[')) {
          result.push(...(fieldErrors as ValidationErrorDTO[]));
        }
      }

      return result;
    }

    const AMOUNT_PATTERN = /^\d+(\.\d+)?$/;
    const MAX_TEXT_LENGTH = 255;

    const validate = (form: TrafficGroupFormDTO): ValidationErrorDTO[] => {
      const errors: ValidationErrorDTO[] = [];
      const required = (field: string) => errors.push({code: 'c1051bb4-d103-4f74-8988-acbcafc7fdc3', field, message: ''});
      const invalid = (field: string, message: string) => errors.push({code: 'INVALID_VALUE', field, message});
      const tooLong = helper.trans('labels.validation_max_length', {max: MAX_TEXT_LENGTH});

      const name = (form.name ?? '').trim();
      if (name === '') {
        required('name');
      } else if (name.length > MAX_TEXT_LENGTH) {
        invalid('name', tooLong);
      }

      if ((form.publicName ?? '').length > MAX_TEXT_LENGTH) {
        invalid('publicName', tooLong);
      }

      if (!form.type) {
        required('type');
      }

      if (limitsFieldsVisible.value) {
        const min = String(form.minSum ?? '').trim();
        const max = String(form.maxSum ?? '').trim();
        const amountFormat = helper.trans('labels.validation_amount_format');
        const minValid = min === '' || AMOUNT_PATTERN.test(min);
        const maxValid = max === '' || AMOUNT_PATTERN.test(max);

        if (!minValid) {
          invalid('minSum', amountFormat);
        }

        if (!maxValid) {
          invalid('maxSum', amountFormat);
        }

        if ((min !== '' || max !== '') && !form.currency) {
          invalid('currency', helper.trans('labels.validation_currency_required'));
        }

        if (min !== '' && max !== '' && minValid && maxValid && parseFloat(min) >= parseFloat(max)) {
          invalid('minSum', helper.trans('labels.validation_min_less_than_max'));
        }
      }

      return errors;
    }

    const save = () => {
      setErrors([]);
      const form = getForm();

      const clientErrors = validate(form);
      if (clientErrors.length > 0) {
        setErrors(clientErrors);

        return Promise.reject(new Error('validation'));
      }

      const data = {
        name: form.name,
        publicName: form.publicName ?? null,
        type: form.type,
        isHidden: form.isHidden,
      } as Record<string, any>;

      if (limitsFieldsVisible.value) {
        data.currency = form.currency ?? null;
        data.minSum = form.minSum ?? null;
        data.maxSum = form.maxSum ?? null;
      }

      if (form.type === Direction.PAY_IN) {
        data.paymentOptions = form.paymentOptions ?? [];
      }

      if (reuseMinCapFeatureEnabled.value && form.type === Direction.PAY_IN) {
        data.reuseMinCapEnabled = form.reuseMinCapEnabled === true;
        data.reuseMinCaps = form.reuseMinCaps ?? {};
      }

      if (receiptsHintFeatureEnabled.value && form.type === Direction.PAY_OUT) {
        data.payOutReceiptsHint = form.payOutReceiptsHint ?? null;
      }

      const promise = form.id
        ? api.call.trafficGroups.update(form.id, data as TrafficGroupUpdateRequestDTO)
        : api.call.trafficGroups.create(data as TrafficGroupUpdateRequestDTO)

      promise
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
          } else {
            console.log(e);
          }

        })

      return promise
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): TrafficGroupFormDTO => {
      return state.form
    }

    const setForm = (form: TrafficGroupFormDTO) => {
      state.errors = {}
      state.form = {
        ...form,
        reuseMinCapEnabled: form.reuseMinCapEnabled === true,
        reuseMinCaps: Array.isArray(form.reuseMinCaps) ? {} : {...(form.reuseMinCaps ?? {})},
      }
    }

    onMounted(async () => {
      await store.dispatch('currencyMethods/loadList')
    })

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      setErrors,
      getErrors,
      hasErrors,
      save,
      Direction,
      reuseMinCapFeatureEnabled,
      receiptsHintFeatureEnabled,
      limitsFieldsVisible,
      getReuseMinCapErrors,
    }
  }
})
</script>
